import { render, staticRenderFns } from "./user_manage_register.vue?vue&type=template&id=216d058d&scoped=true&"
import script from "./user_manage_register.vue?vue&type=script&lang=js&"
export * from "./user_manage_register.vue?vue&type=script&lang=js&"
import style0 from "./user_manage_register.vue?vue&type=style&index=0&id=216d058d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216d058d",
  null
  
)

export default component.exports